<template>
  <div class="shop-contextual-images">
    <ConditionInput
      :value="value"
      @click="
        () => {
          show = true
          $emit('track', 'ContextualImages')
        }
      "
    />
    <Modal v-if="show" :value="value" @input="$ev => $emit('input', $ev)" @close="show = false" />
  </div>
</template>

<script>
import Modal from './Modal'
import ConditionInput from './Input'

export default {
  props: {
    value: Array,
  },
  data() {
    return {
      show: false,
    }
  },
  components: {
    Modal,
    ConditionInput,
  },
}
</script>

<style lang="scss">
.shop-contextual-images {
  display: flex;

  & > button {
    flex-grow: 1;
  }
}
</style>
